module.exports = __webpack_public_path__ + "img/main_logo.96032b69.png";